import script from "./regFooterEn.vue?vue&type=script&setup=true&lang=js"
export * from "./regFooterEn.vue?vue&type=script&setup=true&lang=js"

import "./regFooterEn.vue?vue&type=style&index=0&id=254a23ae&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254a23ae"]])

export default __exports__